import { render, staticRenderFns } from "./qAndA.vue?vue&type=template&id=5d5bfd81&scoped=true"
import script from "./qAndA.vue?vue&type=script&lang=js"
export * from "./qAndA.vue?vue&type=script&lang=js"
import style0 from "./qAndA.vue?vue&type=style&index=0&id=5d5bfd81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5bfd81",
  null
  
)

export default component.exports